import React from 'react';
import PropTypes from 'prop-types';
import { ParagraphStyleTag } from './styles';

const Paragraph = React.forwardRef((props, ref) => {
  const {
    small,
    tag,
    type,
    style,
    children,
    withCursor,
    size = 'base',
    onClick,
    dangerouslySetInnerHTML,
    ...rest
  } = props;
  const newSize = type === 2 ? 'small' : size;

  if (dangerouslySetInnerHTML) {
    return (
      <ParagraphStyleTag
        as={tag}
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
        ref={ref}
        type={newSize}
        style={style}
        {...rest}
        withCursor={!!withCursor || !!onClick}
      >
        {children}
      </ParagraphStyleTag>
    );
  }

  return (
    <ParagraphStyleTag
      as={tag}
      ref={ref}
      type={newSize}
      style={style}
      {...rest}
      withCursor={!!withCursor || !!onClick}
    >
      {children}
    </ParagraphStyleTag>
  );
});

Paragraph.propTypes = {
  tag: PropTypes.elementType,
  type: PropTypes.number,
  style: PropTypes.object,
  dangerouslySetInnerHTML: PropTypes.object,
  children: PropTypes.node,
  withCursor: PropTypes.bool,
  onClick: PropTypes.func,
  small: PropTypes.bool,
  size: PropTypes.string,
};

Paragraph.defaultProps = {
  type: 1,
  tag: 'p',
};

export default Paragraph;
